<template>
  <v-data-table
    :headers="headers"
    :items="result.items"
    :total-items="result.total"
    :pagination.sync="pagination"
    :rows-per-page-items="rowsPerPageItems"
    :loading="loading"
  >
    <template #items="{ item }">
      <tr>
        <td>{{ item.admin_id }}</td>
        <td>{{ item.action }}</td>
        <td>{{ item.timestamp | DateFormat('DD/MM/YYYY HH:mm') }}</td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
import superrichApi from '@/api/superrich'
import { mapGetters } from 'vuex'

export default {
  props: {
    value: {
      type: Object,
      default: undefined
    }
  },
  data() {
    return {
      headers: [
        {
          value: 'admin',
          text: 'Admin',
          sortable: false
        },
        {
          value: 'action',
          text: 'Action',
          sortable: false
        },
        {
          value: 'timestamp',
          text: 'Timestamp',
          sortable: false
        }
      ],
      result: {
        items: [],
        total: 0
      },
      pagination: {
        page: 1,
        rowsPerPage: 10
      },
      rowsPerPageItems: [10, 25, 50, 100],
      loading: false
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  watch: {
    pagination() {
      this.fetch()
    }
  },
  methods: {
    async fetch() {
      try {
        this.loading = true
        const response = await superrichApi.getBranchHistories(this.value.id, {
          page_id: this.selectedBot.pageid,
          limit: this.pagination.rowsPerPage,
          offset: (this.pagination.page - 1) * this.pagination.rowsPerPage
        })
        const { data, total = '0' } = response.data
        this.result = {
          items: data,
          total: Number(total)
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/template/superrich/branch/HistoryDataTable.vue